<template>
  <a-modal :title="`请输入【${fieldCode}】字段的多语言内容new`"
           :maskClosable="false"
           :visible="langDialogVisible"
           @ok="submit"
           @cancel="cancel">
    <a-form-model ref="langForm" :model="langForm" :rules="rules" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
      <template v-for="item in langList">
        <a-form-model-item :key="item.id" :label="item.languageName" :prop="item.languageCode">
          <a-input v-model.trim="langForm[item.languageCode]" />
        </a-form-model-item>
      </template>
    </a-form-model>
  </a-modal>
</template>

<script>
/*
* @author   guochao
* */
import Vue from 'vue'

const vm = Vue.prototype
export default {
  name: 'mtcLangInput',
  data() {
    return {
      // 录入信息的字段
      fieldCode: '',
      // 表名
      tableName: '',
      // 表单项是否必填
      isRequired: false,
      // 表单数据
      langForm: {},
      // 业务数据id
      id: '',
      // 接口获取的多语言数组
      langDetail: [],
      // 是否打开模态框
      langDialogVisible: false,
      // 所有多语言类型
      langList: JSON.parse(this.$ls.get('languageList')),
      // 表单布局
      formItemLayout: {
        labelCol: {
          xs: { span: 8, offset: 1 },
          sm: { span: 4, offset: 1 }
        },
        wrapperCol: {
          xs: { span: 12, offset: 1 },
          sm: { span: 18, offset: 1 }
        }
      },
      // 表单校验规则
      rules: {}
    }
  },
  methods: {
    // 打开模态框
    openLangDialog({ field, require, tableName, id, detail = [] }) {
      this.fieldCode = field
      this.tableName = tableName
      this.id = id || null
      this.isRequired = require
      let obj = {}
      // 数组转换为对象给form使用
      detail?.forEach(ele => {
        obj[ ele.langType ] = ele.langText
      })
      this.langDetail = detail || []
      this.langForm = { ...obj }
      // 初始化规则
      if (this.isRequired) this.initFormRule()
      this.langDialogVisible = true
    },
    // 初始化表单规则
    initFormRule() {
      this.langList.forEach(ele => {
        this.rules[ ele.languageCode ] = [{
          required: true,
          message: '',
          trigger: ['change', 'blur']
        }]
      })
    },
    // 确认
    handleLangOk(callback) {
      this.$refs.langForm.validate(valid => {
        if (valid) {
          this.langDialogVisible = false
          if (this.langDetail && this.langDetail.length) {
            this.langList.forEach(item => {
              let isHave = this.langDetail.some(ele => ele.langType === item.languageCode)
              if(!isHave) this.langDetail.push({
                relTable: this.tableName,
                relField: this.fieldCode,
                langType: item.languageCode,
                relBizId: this.id || null,
                langText: this.langForm[ item.languageCode ]
              })
            })
            this.langDetail.map(ele => ele.langText = this.langForm[ ele.langType ])
          } else {
            for (let i in this.langForm) {
              this.langDetail.push({
                relTable: this.tableName,
                relField: this.fieldCode,
                langType: i,
                relBizId: this.id || null,
                langText: this.langForm[ i ]
              })
            }
          }
          let result = {
            data: this.langForm,
            langArr: this.langDetail,
            field: this.fieldCode,
            tableName: this.tableName,
            id: this.id
          }
          // langForm多语言数据对象，langDetail多语言数据数组，fieldCode当前设置数据多语言的字段，tableName当前设置数据多语言的表名，id当前设置数据多语言的数据id
          callback && callback(result)
        }
      })
    },
    // 关闭模态框
    handleLangCancel(callback) {
      callback && callback()
      this.$refs.langForm.resetFields()
      this.langDialogVisible = false
      this.$destroy()
    },
    // 给函数调用组件时用的方法
    submit() {
    },
    cancel() {
    }
  }
}
</script>

<style scoped>

</style>